<template>
  <div>
    <h4>McAlert</h4>
    <div class="d-block gap-2 align-items-center mb-4">
      <McAlert class="mb-3 mt-3" variant="success" :text="label" withIcon />
      <McAlert class="mb-3 mt-3" variant="info" :text="label" withIcon />
      <McAlert class="mb-3 mt-3" variant="warning" :text="label" withIcon />
      <McAlert class="mb-3 mt-3" variant="error" :text="label" withIcon />
    </div>

    <h4>McToastAlert</h4>
    <div class="d-flex gap-2 align-items-center mb-4">
      <b-button variant="success" @click="successToast">Success Toast</b-button>
      <b-button variant="info" @click="infoToast">Info Toast</b-button>
      <b-button variant="warning" @click="warningToast">Warning Toast</b-button>
      <b-button variant="danger" @click="errorToast">Error Toast</b-button>
    </div>

    <h4>McToastDynamicBody</h4>
    <div class="d-flex gap-2 align-items-center mb-4">
      <b-button variant="success" @click="successDynToast">Success Toast</b-button>
      <b-button variant="info" @click="infoDynToast">Info Toast</b-button>
      <b-button variant="warning" @click="warningDynToast">Warning Toast</b-button>
      <b-button variant="danger" @click="errorDynToast">Error Toast</b-button>
    </div>
  </div>
</template>
<script>
import { mcToast } from '@/plugins/McToastAlertPlugin'
import McAlert from '@/components/McAlert'

export default {
  components: {
    McAlert,
  },
  props: {
    label: {
      type: String,
    },
    header: {
      type: String,
    },
  },
  methods: {
    successToast() {
      mcToast.success(this.label)
    },
    infoToast() {
      mcToast.info(this.label)
    },
    warningToast() {
      mcToast.warning(this.label)
    },
    errorToast() {
      mcToast.error(this.label)
    },
    successDynToast() {
      mcToast.success({
        component: 'McToastDynamicBody',
        props: {
          contents: [
            { tag: 'h6', text: this.header, class: 'text-success' },
            { tag: 'p', text: this.label },
          ],
        },
      })
    },
    infoDynToast() {
      mcToast.info({
        component: 'McToastDynamicBody',
        props: {
          contents: [
            { tag: 'h6', text: this.header, class: 'text-info' },
            { tag: 'p', text: this.label },
          ],
        },
      })
    },
    warningDynToast() {
      mcToast.warning({
        component: 'McToastDynamicBody',
        props: {
          contents: [
            { tag: 'h6', text: this.header, class: 'text-warning' },
            { tag: 'p', text: this.label },
          ],
        },
      })
    },
    errorDynToast() {
      mcToast.error({
        component: 'McToastDynamicBody',
        props: {
          contents: [
            { tag: 'h6', text: this.header, class: 'text-danger' },
            { tag: 'p', text: this.label },
          ],
        },
      })
    },
  },
}
</script>
